import React from 'react';

import Organization from '../../models/organization';
import { useHistory } from 'react-router-dom';

import Loading from '../../components/loading';

export function Login() {
    const history = useHistory();

    const [, loading] = Organization.useApiModel({
        strict: true,
        onSuccess: orgas => {
            history.push(`/ticket/O${orgas[0].id}`);
        },
        query: {
            // No need for more
            limit: 1
        }
    });

    if (loading) {
        return <Loading />;
    }

    return null;
}
